<!-- ReservationConfirmModal.vue -->
<template>
    <div v-if="isVisible" class="modal-overlay">
      <div class="modal-container">
        <div class="modal-header">
          <h3>수강 예약 정원 초과</h3>
          <button class="close-button" @click="handleClose">×</button>
        </div>
        <div class="modal-body">
          <p>수강 예약 정원이 마감되었습니다.</p>
          <p>초과 예약을 하시겠습니까? 대기 예약을 하시겠습니까?</p>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="handleOverCapacityReservation">초과 예약</button>
          <button class="confirm-btn" @click="handleWaitingReservation">대기 예약</button>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'ReservationConfirmModal',
    props: {
      isVisible: {
        type: Boolean,
        default: false
      }
    },
    emits: [ 'onClickBtnForceReserveSelectedCustomer', 'onClickBtnWaitReserveSelectedCustomer'],
    methods: {
      handleClose() {
        this.$emit('close')
      },
      handleOverCapacityReservation() {
        this.$emit('onClickBtnForceReserveSelectedCustomer')
        this.handleClose()
      },
      handleWaitingReservation() {
        this.$emit('onClickBtnWaitReserveSelectedCustomer')
        this.handleClose()
      }
    }
  }
  </script>

  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1002;
  }

  .modal-container {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    min-width: 300px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .modal-header h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }

  .close-button {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    color: #666;
  }

  .modal-body {
    margin-bottom: 20px;
  }

  .modal-body p {
    margin: 5px 0;
    color: #333;
  }

  .reservation-note {
    font-size: 14px;
    color: #666;
    margin-top: 10px;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .cancel-btn {
    padding: 8px 16px;
    border: 1px solid #ddd;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    color: #333;
  }

  .confirm-btn {
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
  }

  .confirm-btn:hover {
    background-color: #0056b3;
  }

  .cancel-btn:hover {
    background-color: #f5f5f5;
  }

  .close-button:hover {
    color: #333;
  }
  </style>
